import AboutSection from './AboutSection';
import ContactSection from './ContactSection';
import ExperienceSection from './ExperienceSection';
import HeroSection from './HeroSection';
import SiteHeader from './SiteHeader';
import WorkSection from './WorkSection';

function Portfolio() {
    return (
        <div className="site">
            <SiteHeader />
            <main className="gallery" aria-label="Portfolio gallery">
                <HeroSection />
                <AboutSection />
                <ExperienceSection />
                <WorkSection />
                <ContactSection />
            </main>
        </div>
    );
}

export default Portfolio;
